import { render, staticRenderFns } from "./DesktopShell.vue?vue&type=template&id=06056eec"
import script from "./DesktopShell.vue?vue&type=script&lang=js"
export * from "./DesktopShell.vue?vue&type=script&lang=js"
import style0 from "./DesktopShell.vue?vue&type=style&index=0&id=06056eec&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports